// modules
import React from 'react'

import { get, isArray, reduce } from 'lodash'
import PropTypes from 'prop-types'

import { Flex } from 'antd'

const FIELD_TITLE_OVERRIDES = {
  Dosage: 'Strength',
  dosage: 'Strength'
}

class ErrorMessages extends React.PureComponent {
  static propTypes = {
    errorObj: PropTypes.shape({
      errors: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
      message: PropTypes.string
    })
  }

  static defaultProps = { errorObj: {} }

  getMessages = (errors = {}) =>
    reduce(
      errors,
      (result, item, key) => {
        let title = key.split('.')
        title = get(title, title.length - 1, '')
        title = title[0].toUpperCase() + title.slice(1)

        result.push({
          title,
          messages: item
        })

        return result
      },
      []
    )

  render = () => {
    const {
      errorObj: { errors, message }
    } = this.props
    const messages = isArray(errors) ? errors : this.getMessages(errors)

    return (
      <ul
        className="error-message-list"
        style={{ maxWidth: '100%', wordWrap: 'break-word' }}
      >
        {messages.length ? (
          messages.map((item, key) => (
            <li key={key}>
              {item.messages.map((message, mKey) => (
                <Flex key={mKey} gap={10} style={{ textAlign: 'left' }}>
                  <div style={{ width: '120px', fontWeight: 600 }}>
                    {`${FIELD_TITLE_OVERRIDES[item.title] || item.title}:`}
                  </div>
                  <div style={{ color: '#d95f5f' }}>{message}</div>
                </Flex>
              ))}
            </li>
          ))
        ) : (
          <li className="message">{message}</li>
        )}
      </ul>
    )
  }
}

export default ErrorMessages
